import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.module.css'
import { ko } from "date-fns/locale/ko";
import { yyyymmToDate, getYearMonth } from "../../util/date";

const MonthRagePicker = ({setRequestData}) => {
  const date = new Date();
  const [startDate, setStartDate] = useState(new Date(date.setMonth(date.getMonth() - 1)));
  const [endDate, setEndDate] = useState(new Date());
  
  const handleDateSelect = (date, setDate) => {
    setDate(date)
  }

  useEffect(() => {
    setRequestData((prev) => ({
      ...prev,
      STDATE: getYearMonth(startDate),
      ENDATE: getYearMonth(endDate)
    }));
  }, [startDate, endDate])
  return (
    <>
      <DatePicker
        className="min-h-6 pl-1 text-xs font-bold border border-black bg-yellow-100 lg:max-w-24 md:max-w-14"
        selected={startDate}
        onChange={(date) => handleDateSelect(date, setStartDate)}
        selectsStart
        locale={ko}
        startDate={startDate}
        dateFormat="yyyy/MM"
        showMonthYearPicker
      />
      <div className="mx-1">~</div>
        <DatePicker
        className="min-h-6 pl-1 text-xs font-bold border border-black bg-yellow-100 lg:max-w-24 md:max-w-14"
        selected={endDate}
        onChange={(date) => handleDateSelect(date, setEndDate)}
        locale={ko}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        dateFormat="yyyy/MM"
        showMonthYearPicker
      />
    </>
  )
}

export default MonthRagePicker;